import React from 'react';
import { useHistory } from 'react-router-dom';
import { Card } from 'ui-toolkit';
import { LenderCompanyForm } from './LenderCompanyCreateForm';
import { ClientUrlFactory } from '../../ui-toolkit/rest/ClientUrlFactory';
import { ILenderRequest } from '../../types/lenders/ILenderRequest';
import { useCreateLenderMutation } from '../../API/lenders/LenderCompanyApi';
import { checkForMutationSuccess } from '../../API/checkForMutationSuccess';
import { ErrorMessageTW } from '../../tailwindComponents/errorMessage/ErrorMessageTW';

export interface ICreateLenderContainerProps {}

export const CreateLenderContainer: React.FC<ICreateLenderContainerProps> = () => {
  const history = useHistory();
  const [createLenderCompany, { error }] = useCreateLenderMutation();
  const onSubmit = async (data: ILenderRequest) => {
    const result = await createLenderCompany(data);
    if (checkForMutationSuccess(result, 'Creating Lender Company', 'Error Creating Lender Company')) {
      history.push(ClientUrlFactory().urlFor.lenderCompany(result.data.id));
    }
  };

  return (
    <Card title={'Create Lender Company'}>
      <ErrorMessageTW rtkError={error} />
      <LenderCompanyForm onSubmit={onSubmit} onSubmitLabel={'Create'} />
    </Card>
  );
};
